import { CdkCopyToClipboard } from '@angular/cdk/clipboard';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TechnicalEligibilityApiService } from '../../../services/technical-eligibility-api-service';

@Component({
  selector: 'app-technical-eligibility-fibre-buildings-modal-component',
  imports: [MatDialogModule, MatIconModule, MatButtonModule, MatTooltipModule, CdkCopyToClipboard],
  templateUrl: './technical-eligibility-fibre-buildings-modal-component.html',
})
export class TechnicalEligibilityFibreBuildingsModalComponent {
  public readonly provider!: string;
  public readonly fibreBuildingCodes: string[];
  
  constructor(
    @Inject(MAT_DIALOG_DATA) public readonly data: any,
    public readonly technicalEligibilityApiService: TechnicalEligibilityApiService
  ) {
    this.provider = this.technicalEligibilityApiService.getProviderDisplayedName(data.provider);
    this.fibreBuildingCodes = data.fibreBuildingCodes ?? [];
  }
}
